// Module
var code = "<p><span class=\"heading--isInteriorPageSubHeadingCaption\"> Frequently Asked Questions </span></p> <h2 class=\"heading--isInteriorPageSubHeading\"> Loan Default\t</h2> <p>Get all the information you need to get your account out of default and back on track!</p> ";
// Exports
export default code;